module.exports = __webpack_public_path__ + "img/product_web.076247f8.png";